export default __webpack_public_path__ + "static/media/trusted-by-pandg.ffaf9288.png";